module.exports = __webpack_public_path__ + "static/img/4c.c2c689b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente-en/4c.png
// module id = UcMC
// module chunks = 0